/**
 * セミナー詳細 ステータス 1:下書き
 * @type {{editLabel: string, label: string, value: number}}
 */
export const SEMINAR_INFORMATION_STATUS_DRAFT = {
    editLabel: '下書き（非公開）',
    label: '下書き',
    value: 1,
};
/**
 * セミナー詳細 ステータス 2:公開中
 * @type {{editLabel: string, label: string, value: number}}
 */
export const SEMINAR_INFORMATION_STATUS_PUBLIC = {
    editLabel: '公開',
    label: '公開中',
    value: 2,
};
/**
 * セミナー ステータス
 * @type {{editLabel: string, label: string, value: number}[]}
 */
export const SEMINAR_INFORMATION_STATUSES = [
    SEMINAR_INFORMATION_STATUS_DRAFT,
    SEMINAR_INFORMATION_STATUS_PUBLIC,
];
/**
 * セミナー詳細 タイトル 最大文字数
 * @type {number}
 */
export const SEMINAR_INFORMATION_TEXT_MAX_LENGTH = 60;
/**
 * セミナー詳細 最大文字数（下書き）
 * @type {number}
 */
export const SEMINAR_INFORMATION_TEXT_MAX_LENGTH_DRAFT = 255;
/**
 * セミナー詳細 開催日時 1:随時開催
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/adjustSchedule.ts を参照
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME = {
    label: '随時開催',
    value: 1,
};
/**
 * セミナー詳細 開催日時 2:日程を設定する
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/adjustSchedule.ts を参照
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_ADJUST_SCHEDULE_FIXED = {
    label: '日程を設定する',
    value: 2,
};
/**
 * セミナー詳細 開催日時
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/adjustSchedule.ts を参照
 * @type {{label: string, value: number}[]}
 */
export const SEMINAR_INFORMATION_ADJUST_SCHEDULES = [
    SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME,
    SEMINAR_INFORMATION_ADJUST_SCHEDULE_FIXED,
];
/**
 * セミナー詳細 参加費用 1:無料
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/participationFee.ts を参照してください
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_PARTICIPATION_FEE_FREE = {
    label: '無料',
    value: 1,
};
/**
 * セミナー詳細 参加費用 2:有料
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/participationFee.ts を参照してください
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_PARTICIPATION_FEE_PAID = {
    label: '有料',
    value: 2,
};
/**
 * セミナー詳細 参加費用
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/participationFee.ts を参照してください
 * @type {{label: string, value: number}[]}
 */
export const SEMINAR_INFORMATION_PARTICIPATION_FEES = [
    SEMINAR_INFORMATION_PARTICIPATION_FEE_FREE,
    SEMINAR_INFORMATION_PARTICIPATION_FEE_PAID,
];
/**
 * セミナー詳細 参加形態 1:オンライン
 * @deprecated 以降は src/utils/constants/seminar/seminarParticipationType/type.ts を参照してください
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_PARTICIPATION_TYPE_ONLINE = {
    label: 'オンライン',
    value: 1,
};
/**
 * セミナー詳細 参加形態 2:対面
 * @deprecated 以降は src/utils/constants/seminar/seminarParticipationType/type.ts を参照してください
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_PARTICIPATION_TYPE_FACE_TO_FACE = {
    label: '対面',
    value: 2,
};
/**
 * セミナー詳細 参加形態
 * @deprecated 以降は src/utils/constants/seminar/seminarParticipationType/type.ts を参照してください
 * @type {{label: string, value: number}[]}
 */
export const SEMINAR_INFORMATION_PARTICIPATION_TYPES = [
    SEMINAR_INFORMATION_PARTICIPATION_TYPE_ONLINE,
    SEMINAR_INFORMATION_PARTICIPATION_TYPE_FACE_TO_FACE,
];
/**
 * セミナー詳細 タイプ 1:勉強会
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/type.ts を参照してください
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_TYPE_STUDY_GROUP = {
    label: '勉強会',
    value: 1,
};
/**
 * セミナー詳細 タイプ 2:ワークショップ
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/type.ts を参照してください
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_TYPE_WORKSHOP = {
    label: 'ワークショップ',
    value: 2,
};
/**
 * セミナー詳細 タイプ 3:対談
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/type.ts を参照してください
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_TYPE_DIALOGUE = {
    label: '対談',
    value: 3,
};
/**
 * セミナー詳細 タイプ 4:動画
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/type.ts を参照してください
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_TYPE_MOVIE = {
    label: '動画',
    value: 4,
};
/**
 * セミナー詳細 タイプ
 * @deprecated 以降は src/utils/constants/seminar/seminarInformation/type.ts を参照してください
 * @type {{label: string, value: number}[]}
 */
export const SEMINAR_INFORMATION_TYPES = [
    SEMINAR_INFORMATION_TYPE_STUDY_GROUP,
    SEMINAR_INFORMATION_TYPE_WORKSHOP,
    SEMINAR_INFORMATION_TYPE_DIALOGUE,
    SEMINAR_INFORMATION_TYPE_MOVIE,
];
/**
 * セミナー詳細 セミナー申込方法 1:該当する貴社のセミナーページに送客する
 * @deprecated 以降は utils/constants/seminar/seminarInformation/applicationProcess.ts を参照してください
 * @type {{annotationLabel: string, label: string, value: number}}
 */
export const SEMINAR_INFORMATION_APPLICATION_PROCESS_URL = {
    annotationLabel: '自社で該当のセミナーページがある場合（成果報酬対象外となります）',
    label: '該当する貴社のセミナーページに送客する',
    value: 1,
};
/**
 * セミナー詳細 セミナー申込方法 2:申込者の情報を別途メールで受け取る
 * @deprecated 以降は utils/constants/seminar/seminarInformation/applicationProcess.ts を参照してください
 * @type {{annotationLabel: string, label: string, value: number}}
 */
export const SEMINAR_INFORMATION_APPLICATION_PROCESS_EMAIL = {
    annotationLabel: '（申込があった場合は、成果報酬の対象となります）',
    label: '申込者の情報を別途メールで受け取る',
    value: 2,
};
/**
 * セミナー詳細 セミナー申込方法
 * @deprecated 以降は utils/constants/seminar/seminarInformation/applicationProcess.ts を参照してください
 * @type {{annotationLabel: string, label: string, value: number}[]}
 */
export const SEMINAR_INFORMATION_APPLICATION_PROCESSES = [
    SEMINAR_INFORMATION_APPLICATION_PROCESS_URL,
    SEMINAR_INFORMATION_APPLICATION_PROCESS_EMAIL,
];
/**
 * セミナー詳細 データ種別 1:表示
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_DATA_TYPE_VIEW = {
    label: '表示',
    value: 1,
};
/**
 * セミナー詳細 データ種別 2:表示
 * @type {{label: string, value: number}}
 */
export const SEMINAR_INFORMATION_DATA_TYPE_PREVIEW = {
    label: 'プレビュー',
    value: 2,
};
/**
 * セミナー詳細 データ種別
 * @type {{label: string, value: number}[]}
 */
export const SEMINAR_INFORMATION_DATA_TYPES = [
    SEMINAR_INFORMATION_DATA_TYPE_VIEW,
    SEMINAR_INFORMATION_DATA_TYPE_PREVIEW,
];
